import { useEffect as e, useState as t } from "react";
//#region src/hooks/useScrolledPast.ts
function n(n, r = 40) {
	let [i, a] = t(!1);
	return e(() => {
		let e = null, t = () => {
			e = null;
			let t = window.pageYOffset;
			a((e) => e ? t > n - r : t >= n);
		}, i = () => {
			e === null && (e = window.requestAnimationFrame(t));
		};
		return window.addEventListener("scroll", i, { passive: !0 }), t(), () => {
			window.removeEventListener("scroll", i), e !== null && window.cancelAnimationFrame(e);
		};
	}, [n, r]), i;
}
//#endregion
export { n as useScrolledPast };
